import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationUnread from './notification-unread/';
import NotificationRead from './notification-read';
import LoadingState from '../common/loading-state';
import config from '../../../src/globs/config';
import { getInstrumentedAxiosInstance } from '../../../src/globs/ajax-proxy';
import user from '../../reducers/user';
import NotificationBell from './notification-bell.svg';

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readStatusTrueArray: [],
      readStatusFalseArray: [],
      loadMoreStartRange: 10,
      loadMoreEndRange: 19,
      isLoadMore: true,
      showLoader: true,
    };
  }

  componentDidMount() {
    const { props } = this;
    const url = `${config.apiContextPath}/sales_officers/${props.user.id}/push_notifications`;
    props.dataLoad({
      key: 'notifications',
      url
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Only update when location or API status actually changes
    // Prevent infinite loops in React 19
    if (this.props.location !== prevProps.location &&
        this.props.location.query !== prevProps.location.query) {
      const parsedPayload = JSON.parse(prevProps.location.query.payload);
      this.callingTrackEventOnPropsRecieved(parsedPayload);
    }

    if (prevProps.ajaxStatuses.notifications === 'PENDING' &&
      this.props.ajaxStatuses.notifications === '') {
      this.callNotificationApi();
    }
  }

  onCancel = () => {
    const { props } = this;
    props.history.replace('/home');
  }


  loadMore = () => {
    const { props } = this;
    const path_ = `${config.apiContextPath}/sales_officers/${props.user.id}/push_notifications?range=[${this.state.loadMoreStartRange},${this.state.loadMoreEndRange}]`;

    getInstrumentedAxiosInstance().get(path_)
      .then((res) => {
        if (res.data.data.length < 5) {
          this.setState({ isLoadMore: false });
        }
        if (res.data.data && res.data.data.length) {
          this.setState({ loadMoreStartRange: this.state.loadMoreEndRange + 1,
            loadMoreEndRange: this.state.loadMoreEndRange + 10 });
          const seperatedNotification = res.data.data.reduce((r, a) => {
            const resp = r;
            resp[a.read_status] = resp[a.read_status] || [];
            resp[a.read_status].push(a);
            return resp;
          }, Object.create(null));
          // if (seperatedNotification[0] && seperatedNotification[0].length) {
          if (seperatedNotification.false
          && seperatedNotification.false.length !== 0) {
            this.markedAsReadApiCall(seperatedNotification.false);
            this.setState({ readStatusFalseArray:
              [...this.state.readStatusFalseArray, ...seperatedNotification.false] });
          }
          // if (seperatedNotification[1] && seperatedNotification[1].length) {
          if (seperatedNotification.true
          && seperatedNotification.true.length !== 0) {
            this.setState({ readStatusTrueArray:
              [...this.state.readStatusTrueArray, ...seperatedNotification.true] });
          }
        }
      }).catch((error) => {
        if (error && error.response && error.response.status === 403) {
          console.log('error', error);
        }
      });
  }

  callNotificationApi = () => {
    this.setState({ showLoader: false });
    if (this.props.notifications && this.props.notifications.length) {
      if (this.props.notifications.length < 10) {
        this.setState({ isLoadMore: false });
      }
      const seperatedNotification = this.props.notifications.reduce((r, a) => {
        const res = r;
        res[a.read_status] = res[a.read_status] || [];
        res[a.read_status].push(a);
        return res;
      }, Object.create(null));
      if (seperatedNotification.false
      && seperatedNotification.false.length !== 0) {
        this.markedAsReadApiCall(seperatedNotification.false);
        this.setState({ readStatusFalseArray: [...seperatedNotification.false] });
      }
      if (seperatedNotification.true
      && seperatedNotification.true.length !== 0) {
        this.setState({ readStatusTrueArray: [...seperatedNotification.true] });
      }
    }
  }

  markedAsReadApiCall = (array) => {
    const { props } = this;
    const readfalseArray = { data: array.map(value => ({ id: value.id, type: value.notification_type })) };
    const path_ = `${config.apiContextPath}/sales_officers/${props.user.id}/push_notifications/mark_as_read`;
    getInstrumentedAxiosInstance().post(path_, readfalseArray)
    .then((res) => {
      if (typeof (res.data) !== 'undefined') {
        console.log(res.data);
      }
    }, (error) => {
      if (error) {
        console.log('error', error);
      }
    });
  }

  callingTrackEventOnPropsRecieved = (parsedPayload) => {
    const { props } = this;
    const targetUrl = `${props.user.href}/in_app_notifications/track_event`;
    props.appNotificationViewed({
      targetUrl,
      data: {
        notifiable_id: parsedPayload.id,
        notifiable_type: parsedPayload.notification_type,
        event: 'Dismiss',
      },
    });
  }

  render() {
    const { props } = this;
    return (
      <div className="lr-main-view">
        {
        this.state.showLoader &&
          <div>
            <div className="loadingContainer1" />
            <LoadingState />
          </div>
        }
        <div className="lr-in-app-notification">
          {
          !this.state.showLoader &&
            <React.Fragment>
              <div className="lr-overlay__header">
                <div className="lr-overlay__header-title">
                  <button
                    type="button"
                    className="lr-overlay__header-back-button"
                    onClick={this.onCancel}
                  >
                    <i className="icon-back" />
                  </button>
                  Notifications
                </div>
              </div>
              <div className="lr-overlay__body">
                <div className="notification-page">
                  {
                  (!this.state.readStatusTrueArray.length
                  && !this.state.readStatusFalseArray.length) ?
                    <div className="no-notifications">
                      <img className="bell-icon" src={NotificationBell} alt="Bell" />
                      <p>No notifications available for now. Please stay tuned for further notifications !</p>
                    </div>
                    : ''
                  }
                  {
                    this.state.readStatusFalseArray && this.state.readStatusFalseArray.length ?
                      <NotificationUnread
                        readStatusFalseArray={this.state.readStatusFalseArray}
                        history={props.history}
                      />
                    : ''
                    }
                  {
                    this.state.readStatusTrueArray && this.state.readStatusTrueArray.length ?
                      <NotificationRead
                        readStatusTrueArray={this.state.readStatusTrueArray}
                        history={props.history}
                      />
                    : ''
                  }
                  {
                    this.state.isLoadMore &&
                    ((this.state.readStatusTrueArray
                      && this.state.readStatusTrueArray.length)
                    || (this.state.readStatusFalseArray
                      && this.state.readStatusFalseArray.length)) ?
                        <div className="load-more-button">
                          <button onClick={this.loadMore} >Load More</button>
                        </div>
                      : ''
                  }
                </div>
              </div>
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

Notifications.propTypes = {
  appNotificationViewed: PropTypes.func.isRequired,
  location: PropTypes.shape({
    query: PropTypes.object,
  }),
  ajaxStatuses: PropTypes.shape({
    inAppNotification: PropTypes.string,
  }),
  dataLoad: PropTypes.func.isRequired,
  inAppNotification: PropTypes.arrayOf(PropTypes.shape({})),
};

Notifications.defaultProps = {
  location: {},
  ajaxStatuses: undefined,
  inAppNotification: [],
};

export default Notifications;
